import { Flex, Typography } from "antd"
import cls from "classname"

import styles from "./ChartLegend.module.less"

const { Text } = Typography

const ChartLegend = ({ items, isActive, onToggle, className, style }) => (
  <Flex gap={12} wrap className={cls(styles.legend, className)} style={style}>
    {items.map((item) => {
      const active = isActive(item.id)
      return (
        <Flex
          key={item.id}
          gap={6}
          align="center"
          onClick={() => onToggle(item.id)}
          className={cls(styles.item, { [styles.inactive]: !active })}
        >
          <svg aria-hidden className={styles.indicator} width="12" height="2" viewBox="0 0 12 2">
            <line
              x1="0"
              y1="1"
              x2="12"
              y2="1"
              stroke={item.color}
              strokeWidth="2"
              strokeDasharray={item.dashed ? "4 2" : undefined}
            />
          </svg>
          <Text className={styles.label}>{item.label}</Text>
          <span aria-hidden className={styles.close}>
            <svg
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L7 7M7 1L1 7"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </span>
        </Flex>
      )
    })}
  </Flex>
)

export default ChartLegend
